<template>
    <v-dialog
      v-model="show"
      max-width="500px"
    >
      <v-card class="py-5">
        <v-card-title class="d-flex text-h5">
          <v-col>
            <v-icon
            class="mr-2"
            color="black"
            >
              mdi-cube-scan
            </v-icon>
            <span class="text-h5">{{ $vuetify.locale.t('$vuetify.seeinar') }}</span>
          </v-col>
          <v-col align="right">
            <v-btn
            icon
            class="self-end"
            @click="show = false"
          >
            <v-icon color="black">
              mdi-close
            </v-icon>
          </v-btn>
          </v-col>
        </v-card-title>
  
        <v-card-text>
          <span class="text-body1"> {{ $vuetify.locale.t('$vuetify.qrcodeSummary') }} </span>
        </v-card-text>
  
        <v-card-text align="center">
          <qrcode-vue
            class="row justify-center my-2"
            :size="parseInt(180)"
            :value="url"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  <script>
    import QrcodeVue from 'qrcode.vue'
    import { useLocale } from 'vuetify'
  
    export default {
      name: 'QrcodeAr',

      setup () {
          const { t } = useLocale()
          return {
            t
          }
        },
  
      components: {
        QrcodeVue,
      },
  
      props: {
        value: Boolean,
        url: String,
      },
  
      computed: {
        show: {
          get () {
            return this.value
          },
          set (value) {
            this.$emit('input', value)
          },
        },
      },
  
    }
  </script>
  